/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S13_P2_PostInputs */

const tr_iade_iptal_s13_p2_post = /** @type {(inputs: Iade_Iptal_S13_P2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`platformu üzerinden de başvuru yapılabilir.`)
};

const en_iade_iptal_s13_p2_post = /** @type {(inputs: Iade_Iptal_S13_P2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`platform of the Ticaret Bakanlığı.`)
};

const de_iade_iptal_s13_p2_post = /** @type {(inputs: Iade_Iptal_S13_P2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`des Ticaret Bakanlığı gestellt werden.`)
};

const ru_iade_iptal_s13_p2_post = /** @type {(inputs: Iade_Iptal_S13_P2_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "platform of the Ticaret Bakanlığı." |
*
* @param {Iade_Iptal_S13_P2_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s13_p2_post = /** @type {((inputs?: Iade_Iptal_S13_P2_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S13_P2_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s13_p2_post(inputs)
	if (locale === "de") return de_iade_iptal_s13_p2_post(inputs)
	if (locale === "ru") return ru_iade_iptal_s13_p2_post(inputs)
	return tr_iade_iptal_s13_p2_post(inputs)
});